import { initializeApp } from "firebase/app";
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
const url = "http://localhost:5000/"


const firebaseConfig = {
  apiKey: "AIzaSyAEVOyYYruRHKVkMCV6E4703B_uP5GYq-Q",
  authDomain: "umbrella-e73f3.firebaseapp.com",
  projectId: "umbrella-e73f3",
  storageBucket: "umbrella-e73f3.appspot.com",
  messagingSenderId: "811865589260",
  appId: "1:811865589260:web:f696177fe62dfa8b911029",
  measurementId: "G-7TJJFDH81N"
};



const app = initializeApp(firebaseConfig);
class Service{
    async getAllCards(){
        const response = await fetch(url)
        const data = await response.json()
        return data
    }
  async auth(){
    const usuario = getAuth();
    const provider = new GoogleAuthProvider();
signInWithPopup(usuario, provider)
  .then((result) => {
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    const user = result.user
    return user
  }).catch((error) => {
    const errorCode = error.code;
    const errorMessage = error.message;
    const email = error.customData.email;
    const credential = GoogleAuthProvider.credentialFromError(error);
  });  
  } 
}
export const service = new Service()